<template>
  <div class="big-buttons row">
    <div
      class="col-12 col-lg mb-6 pb-3"
      v-for="(option, index) in options"
      :key="index"
    >
      <div
        class="big-button"
        :class="{
          active: value === option.id,
          inactive: value !== option.id,
          login: login
        }"
        @click="$emit('input', option.id)"
      >
        <span class="button-name fs-14" :class="{ login }">{{
          option.name
        }}</span>

        <div class="button-icon">
          <img :src="option.src" :alt="option.name" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    login: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.big-buttons {
  .big-button {
    min-height: 218px;
    height: 100%;
    padding: 24px;
    border-radius: 16px;
    border: 1px solid var(--dark-10);
    transition: 0.3s all ease-in-out;
    background: var(--bg-5);

    // &.login {
    //   border: 1px solid var(--semantic-neutral-100, #2b2b2b);
    //   background: var(--surface-cumulative-plus-8, rgba(39, 39, 53, 0.23));
    //   &:hover {
    //     background: var(--surface-cumulative-plus-20, rgba(39, 39, 53, 0.56));
    //     border: 1px solid var(--semantic-neutral-100, #2b2b2b);
    //   }
    //   &.active {
    //     border: 1px solid var(--semantic-primary-accent-500, #9341ff);
    //     background: var(--surface-cumulative-plus-20, rgba(39, 39, 53, 0.56));
    //   }
    // }
    &:hover,
    &.active {
      box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.04);
      cursor: pointer;
    }
    // .button-name {
    //   transition: 0.2s font-weight;
    //   &.login {
    //     color: var(--semantic-neutral-1000, #f0f0f0);
    //     max-width: 176px;
    //     font-size: 14px;
    //     padding-top: 40px;
    //   }
    // }
    .button-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 21px 38px;
    }
  }
}
</style>
